import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import AccordionTabs from './AccordionTabs';
import AccordionTabSection from './AccordionTabSections';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 8px 0;
`;

const AccordionTabGroup = ({ sections }) => {
  const [activeTab, setActiveTab] = useState(0);

  function handleActive(activeIndex) {
    setActiveTab(activeIndex);
  }
  return (
    <Container>
      <AccordionTabs
        sections={sections}
        active={activeTab}
        handleClick={handleActive}
      />
      <AccordionTabSection sections={sections} active={activeTab} />
    </Container>
  );
};

AccordionTabGroup.propTypes = {
  sections: PropTypes.array
};

export default AccordionTabGroup;
